import { formatDateLocal, formatDateLocalWithTimeWithoutSeconds } from "../../lib/script";
import DaysDifference from "../patient/details/notes/DaysDifference";

export default function DateDisplayWithNmuberOfDays({ date, hasTime, textRight, plus }) {
    const rowClass = textRight
        ? "flex-container gap-5 flex-container-end"
        : "flex-container gap-5 flex-container-space-betwen";

    return (
        <div className={rowClass} style={textRight ? { flexWrap: "nowrap" } : undefined}>
            <span style={{ whiteSpace: "nowrap" }}>
                {hasTime ? formatDateLocalWithTimeWithoutSeconds(date) : formatDateLocal(date)}
            </span>
            <DaysDifference date={date} plus={plus} />
        </div>
    );
}